var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Receivable),
      expression: "Receivable"
    }]
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("回款数据分析表")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "3%"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "10px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-top": "20px"
    }
  }, [_c('span', [_vm._v("组织架构")]), _vm._v(" "), _c('el-cascader', {
    staticStyle: {
      "margin-left": "10px",
      "width": "300px"
    },
    attrs: {
      "clearable": "",
      "collapse-tags": "",
      "props": _vm.props
    },
    on: {
      "change": _vm.changeCascader
    },
    model: {
      value: (_vm.project_id),
      callback: function($$v) {
        _vm.project_id = $$v
      },
      expression: "project_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-top": "20px",
      "margin-left": "20px"
    }
  }, [_c('span', [_vm._v("日期 ")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "format": "yyyy-MM-dd",
      "end-placeholder": "结束日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.contract_start_date),
      callback: function($$v) {
        _vm.contract_start_date = $$v
      },
      expression: "contract_start_date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.Find
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "190px"
    }
  }, [_c('download-excel', {
    staticClass: "export-excel-wrapper",
    staticStyle: {
      "margin-left": "-180px",
      "top": "100px"
    },
    attrs: {
      "fields": _vm.download_excel,
      "title": "调岗人员清单",
      "name": "调岗人员清单.xls",
      "fetch": _vm.ExportForm
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "type": "goon"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t导出")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "2% 3% 0 3%"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#d4e9e2',
        color: '#000000'
      },
      "row-class-name": _vm.tableRowClassName,
      "data": _vm.tableData,
      "tooltip-effect": "dark",
      "height": "570",
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "organizeName",
      "align": "center",
      "label": "架构",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "align": "center",
      "label": _vm.title
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "plannedRepaymentAmount",
      "align": "center",
      "label": "计划回款额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "plannedActualPaymentCollection",
      "align": "center",
      "label": "计划内实际回款"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "difference",
      "align": "center",
      "label": "差额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "align": "center",
      "label": "超额回款"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "withinTheMonthlyPlan",
      "align": "center",
      "label": "月计划内"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "monthlyUnplanned",
      "align": "center",
      "label": "月计划外"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "align": "center",
      "label": "汇总"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "totalPlannedCollectionAmount",
      "align": "center",
      "label": "计划回款额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "align": "center",
      "label": "实际回款额"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "plannedActualPaymentCollectionTotal",
      "align": "center",
      "label": "计划内实际回款",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unplannedOverpayment",
      "align": "center",
      "label": "计划外超额回款",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "actualTotalAmountReceived",
      "align": "center",
      "label": "实际回款总额",
      "width": "120"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalDifference",
      "align": "center",
      "label": "实际回款 - 计划回款",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "planCompletionRate",
      "align": "center",
      "label": "计划完成度"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "planPaymentAccuracy",
      "align": "center",
      "label": "计划回款准确度"
    }
  })], 1)], 1)], 1)])])])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02d7c1ee","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/receivable/Collectiondata/Collectiondata.vue
// module id = null
// module chunks = 